import React from 'react';
import PropTypes from 'prop-types';

import { AulaEditorWrapper } from './AulaEditor.styles';

const withCustomStyles = (AulaEditor) => {
  const AulaEditorWithCustomStyles = ({ forwardedRef, ...props }) => {
    const { isSubmitting } = props;

    return (
      <AulaEditorWrapper readOnly={isSubmitting}>
        <AulaEditor ref={forwardedRef} {...props} />
      </AulaEditorWrapper>
    );
  };

  AulaEditorWithCustomStyles.propTypes = {
    forwardedRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    ]),
    isSubmitting: PropTypes.bool,
  };

  return React.forwardRef((props, ref) => {
    return <AulaEditorWithCustomStyles {...props} forwardedRef={ref} />;
  });
};

export default withCustomStyles;
